module.exports = __webpack_public_path__ + "img/SMS25155-L-min.6f191118.png";